<template>
  <b-field label="Accéder à une balise NEYOS">
    <b-autocomplete
      :data="neyosTrackers"
      placeholder="Numéro ou Serial"
      :loading="loading"
      @typing="getNeyosTrackers"
      @select="redirect"
    >
      <template v-slot="props">
        <div class="media">
          <div class="media-content">
            Balise NEYOS #{{ props.option.number }}
            <br />
            <small>{{ `Serial : ${props.option.serial}` }}</small>
          </div>
        </div>
      </template>
    </b-autocomplete>
  </b-field>
</template>

<script>
export default {
  name: 'NeyosTrackerSearch',

  data() {
    return {
      loading: false,
      timeoutId: null,
      neyosTrackers: [],
    }
  },

  methods: {
    getNeyosTrackers(input) {
      if (this.timeoutId) {
        clearTimeout(this.timeoutId)
        this.timeoutId = null
      }

      const keyword = (input ?? '').trim().toUpperCase()
      if (keyword.length < 2) {
        this.neyosTrackers = []
        return
      }

      this.timeoutId = setTimeout(async () => {
        await this.fetch(keyword)
      }, 500)
    },

    async fetch(keyword) {
      this.loading = true

      try {
        this.neyosTrackers = await this.$services.neyosTrackerService.getAll({ keyword })
      } catch (err) {
        this.neyosTrackers = []
        console.error(err)
      }

      this.loading = false
    },

    async redirect(neyosTracker) {
      if (neyosTracker.id === this.$route.params.id) {
        return
      }

      await this.$router.push({ name: 'neyosTracker.edit', params: { id: neyosTracker.id } })
    },
  },
}
</script>
